<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    :model="model"
    entity-name="DeliveryRange"
    icon="mdi-truck"
  >
    <template #footer="">
      <v-btn
        color="blue lighten-4 black--text"
        elevation="0"
        @click="uploadTerminal"
      >
        <div
          class="d-flex align-center"
        >
          <v-icon
            left
          >
            mdi-cloud-upload-outline
          </v-icon>
          <template>
            <div
              class="text-truncate"
              style="max-width: 80px !important;"
            >
              {{ $t('Upload') }}
            </div>
          </template>
        </div>
      </v-btn>
    </template>
  </ik-data-table>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import DeliveryRange from '@/model/dataLayer/api/takeaway/DeliveryRange'
import { syncData } from '@/model/dataLayer/api/takeaway/TakeawayManager'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: DeliveryRange
    })
  },
  methods: {
    async uploadTerminal () {
      try {
        await syncData()
      } catch (e) {
        console.log(e, 'error')
      }
    }
  }
}
</script>
